export default __webpack_public_path__ + "static/media/GoodDay.eb5eaf7b.png";